import React, { useEffect } from 'react';
import { Row, Col, Form, Checkbox } from 'antd';
import { useForm } from 'antd/lib/form/Form';
import { formFields, formFields1 } from './formField';
import { FormField} from 'components';
import { omit } from 'lodash';
import { updateFormField } from 'store/forms/actions';
import { useDispatch, useSelector } from 'react-redux';
import { isBeneficiary } from '../../../../../utils';
import styles from './Terms.module.scss'

const Terms = () => {
  const task = useSelector(state => state.forms.task);
  const [form] = useForm();
  const user = useSelector(state => state.user);
  const isViewMode = useSelector(state => state.forms.carrier.viewMode);
  const viewMode = isViewMode || !isBeneficiary(user.groups);
  const terms = useSelector(state => state.forms.terms);

  const dispatch = useDispatch();

  useEffect(() => {
    form.setFieldsValue({
      terms1: terms?.terms1,
      terms2: terms?.terms2,
      terms3: terms?.terms3,
      terms4: terms?.terms4,
      terms5: terms?.terms5,
      terms6: terms?.terms6,
      terms7: terms?.terms7,
      terms8: terms?.terms8,
      terms9: terms?.terms9,
      terms10: terms?.terms10,
      terms11: terms?.terms11,
      terms12: terms?.terms12,
      terms13: terms?.terms13,
      terms14: terms?.terms14,
      termsAll: terms?.termsAll
    });
  }, [form, terms]);

  // useEffect(() => {

  //   const checkedAll = terms.terms0 && terms.terms1 && terms.terms2 && terms.terms3 && terms.terms4 &&
  //   terms.terms5 && terms.terms6 && terms.terms7 && terms.terms8 && terms.terms9 && terms.terms10 &&
  //   terms.terms11 && terms.terms12 && terms.terms13 
    
  //   if (terms.termsAll !== checkedAll) {

  //     form.setFieldsValue({
  //     termsAll: checkedAll
  //   });

  //   dispatch(
  //     updateFormField({
  //       group: 'terms',
  //       key: 'termsAll',
  //       value: checkedAll,
  //     })
  //   );
  // } 
  // }, [form, terms]);

  const handleChange = ({ key, type, event }) => {
    let newValue;
    if (type === 'text' || type === 'textarea' || type === 'radio') {
      newValue = event.target.value;
    } else if (type === 'date') {
      newValue = new Date(event).toLocaleDateString("en-US");
    } else if (type === 'select' || type === 'number' || type === 'switch') {
      newValue = event;
    } else if (type === 'checkbox') {
      newValue = event.target.checked;
    }

    if(type === 'checkbox' && key === 'termsAll'){
      selectAll( newValue );
    } else {
      dispatch(
        updateFormField({
          group: 'terms',
          key,
          value: newValue,
        })
      );
    }

    
  };

  const selectAll = ( newValue ) => {
    dispatch(
      updateFormField({
        group: 'terms',
        key: 'terms1',
        value: newValue,
      })
    );
    dispatch(
      updateFormField({
        group: 'terms',
        key: 'terms2',
        value: newValue,
      })
    );
    dispatch(
      updateFormField({
        group: 'terms',
        key: 'terms3',
        value: newValue,
      })
    );
    dispatch(
      updateFormField({
        group: 'terms',
        key: 'terms4',
        value: newValue,
      })
    );
    dispatch(
      updateFormField({
        group: 'terms',
        key: 'terms5',
        value: newValue,
      })
    );
    dispatch(
      updateFormField({
        group: 'terms',
        key: 'terms6',
        value: newValue,
      })
    );
    dispatch(
      updateFormField({
        group: 'terms',
        key: 'terms7',
        value: newValue,
      })
    );
    dispatch(
      updateFormField({
        group: 'terms',
        key: 'terms8',
        value: newValue,
      })
    );
    dispatch(
      updateFormField({
        group: 'terms',
        key: 'terms9',
        value: newValue,
      })
    );
    dispatch(
      updateFormField({
        group: 'terms',
        key: 'terms10',
        value: newValue,
      })
    );
    dispatch(
      updateFormField({
        group: 'terms',
        key: 'terms11',
        value: newValue,
      })
    );
    dispatch(
      updateFormField({
        group: 'terms',
        key: 'terms12',
        value: newValue,
      })
    );
    dispatch(
      updateFormField({
        group: 'terms',
        key: 'terms13',
        value: newValue,
      })
    );
    dispatch(
      updateFormField({
        group: 'terms',
        key: 'terms14',
        value: newValue,
      })
    );
    dispatch(
      updateFormField({
        group: 'terms',
        key: 'termsAll',
        value: newValue,
      })
    );
  }

  return (
    <div style={{marginBottom: 200}}>
      <Form
        form={form}
        initialValues={
          {
            // ...carrier,
          }
        }
        trigger="onChange"
        className={styles.termsForm} 
      >
        <div style={{display: 'flex', justifyContent: 'space-between'}}>
           <p className=" mr-0 color-purple-3 text-bold font-size-24">
            Όροι και Προϋποθέσεις
          </p>
          <Form.Item
            name="termsAll"
            valuePropName="checked"
            style={{ marginBottom: 0 }}
           
          >
            <Checkbox
             className={styles['terms-check-all']}
              onChange={e =>
                handleChange({
                  key: 'termsAll',
                  type: 'checkbox',
                  event: e,
                })
              }
            >
              Check All
            </Checkbox>
          </Form.Item>
        </div>
       
        <p className='text-bold'>
        Η υποβολή της Αίτησης Συμμετοχής στο Πρόγραμμα επέχει τη θέση Υπεύθυνης Δήλωσης του Ν. 1599/1986.Ενεργώντας ως νόμιμος εκπρόσωπος της επιχείρησης για τους σκοπούς υποβολής της παρούσας αίτησης, δηλώνω υπεύθυνα ότι η επιχείρηση:        </p>
        <Row style={{ width: '94%' }}>
          {formFields.map((field, index) => {
            return (
              <Col key={index} className="gutter-row" span={24}>
                <Form.Item
                  name={[field.name]}
                  rules={field.rules}
                  valuePropName="checked"
                >
                  <FormField
                    key={index}
                    disabled={viewMode}
                    style={
                      viewMode
                        ? { pointerEvents: 'none', cursor: 'not-allowed' }
                        : { }
                    }
                    className={viewMode ? 'custom-checkbox-disabled' : ''}
                    {...omit(field, ['span', 'rules'])}
                    onChange={value =>
                      handleChange({
                        key: field.name,
                        type: field.type,
                        event: value,
                      })
                    }
                  />
                </Form.Item>
              </Col>
            );
          })}
        </Row>
        <p className='text-bold'>
        Επίσης, ενεργώντας ως νόμιμος εκπρόσωπος της επιχείρησης για τους σκοπούς υποβολής της παρούσας αίτησης, δηλώνω υπεύθυνα ότι:</p>
        <Row style={{ width: '91%' }}>
          {formFields1.map((field, index) => {
            return (
              <Col key={index} className="gutter-row" span={24}>
                <Form.Item
                  name={[field.name]}
                  rules={field.rules}
                  valuePropName="checked"
                >
                  <FormField
                    key={index}
                    disabled={viewMode}
                    style={
                      viewMode
                        ? { pointerEvents: 'none', cursor: 'not-allowed' }
                        : {}
                    }
                    className={viewMode ? 'custom-checkbox-disabled' : ''}
                    {...omit(field, ['span', 'rules'])}
                    onChange={value =>
                      handleChange({
                        key: field.name,
                        type: field.type,
                        event: value,
                      })
                    }
                  />
                </Form.Item>
              </Col>
            );
          })}
          <Col
            key={1}
            className="gutter-row"
            span={'24'}
            style={{ marginTop: '1rem' }}
          >
            <Form.Item
              className="requirementsRadio"
              name={'terms22'}
              id={'terms22'}
              rules={[
                { required: true, message: 'Το πεδίο είναι υποχρεωτικό' },
              ]}
            ></Form.Item>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default Terms;
